"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccountCheckService = /** @class */ (function () {
    function AccountCheckService() {
        this.ALPHABET = "23456789ABCDEFGHJKLMNPQRSTUVWXYZ";
    }
    AccountCheckService.prototype.run = function (accountRs) {
        return this.checkAccountRs(accountRs);
    };
    AccountCheckService.prototype.checkAccountRs = function (accountRs) {
        var accountPrefix = "ARDOR-";
        if (!accountRs.startsWith(accountPrefix)) {
            return false;
        }
        var subAccount = accountRs.substring(accountPrefix.length);
        var subAccountFields = subAccount.split("-");
        if (subAccountFields.length !== 4) {
            return false;
        }
        if (subAccountFields[0].length !== 4) {
            return false;
        }
        if (subAccountFields[1].length !== 4) {
            return false;
        }
        if (subAccountFields[2].length !== 4) {
            return false;
        }
        if (subAccountFields[3].length !== 5) {
            return false;
        }
        if (!this.checkCharacter(subAccountFields[0].split(""))) {
            return false;
        }
        if (!this.checkCharacter(subAccountFields[1].split(""))) {
            return false;
        }
        if (!this.checkCharacter(subAccountFields[2].split(""))) {
            return false;
        }
        if (!this.checkCharacter(subAccountFields[3].split(""))) {
            return false;
        }
        return true;
    };
    AccountCheckService.prototype.checkCharacter = function (characters) {
        var _this = this;
        var containsWrongCharacter = false;
        characters.forEach(function (character) {
            if (!_this.ALPHABET.includes(character)) {
                containsWrongCharacter = true;
                return;
            }
        });
        return !containsWrongCharacter;
    };
    return AccountCheckService;
}());
exports.default = AccountCheckService;
